module.exports = __webpack_public_path__ + "assets/images/boundaries/zoom-icon.svg?v=10dbfdde";